import { PluginConfigType } from 'Core/PluginCore/PluginsManager'
import { PluginConnector } from 'Core/PluginCore/PluginConnector'
import { Studio } from 'Core/Studio'
import { ViolationType } from 'shared/violations/types'

export interface IPlugin {
    id: string
    pluginConnectors: PluginConnector[]
    initialize(studio: Studio): void
    reset(): void
    getAnalyticsData(): Record<string, unknown> | undefined
    getSelectedConnector(): PluginConnector
    destroy(): void
    getPluginData(): Record<string, unknown> | null
    highlightViolation(errors: Record<string, ViolationType>): void
}

export abstract class BasePlugin<T extends PluginConfigType = PluginConfigType> implements IPlugin {
    public abstract readonly id: string
    public readonly pluginConnectors: PluginConnector[]
    protected studio?: Studio
    protected config: T
    constructor(config: T, pluginConnectors: PluginConnector[]) {
        this.pluginConnectors = pluginConnectors
        this.config = config
    }

    public abstract initialize(studio: Studio): void

    public reset() {
        // To override and reset the plugin state
    }

    public getAnalyticsData(): Record<string, unknown> | undefined {
        return undefined
    }

    public getSelectedConnector() {
        return this.pluginConnectors[0]
    }

    protected getParametersData() {
        const connector = this.getSelectedConnector()
        const data = connector.getData()
        return data
    }

    public getPluginData(): Record<string, unknown> | null {
        return null
    }

    public highlightViolation(_: Record<string, ViolationType>): void {
        // To override and highlight the violation
    }

    public destroy() {}
}
